
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const MessageNoResult = ({ text, className }) => {
  const classContainer = classNames('no-result_block', className, {
  })

  return (
    <div className={classContainer}>
      <p>
        <span>{text}</span>
      </p>
    </div>

  )
}

MessageNoResult.defaultProps = {
}

MessageNoResult.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string
}

export default MessageNoResult
